export default __webpack_public_path__ + "static/media/inc42.fe8b9d19.svg";